export default __webpack_public_path__ + "static/BeAIReadyLogo-66821a106241091ee6b803ee263fcce0.svg";